import { createSlice } from '@reduxjs/toolkit';

const uniqueClientIds = (clientIds = []) => [...new Set(clientIds.filter(Boolean))];

const combinedReportsSlice = createSlice({
  name: 'combinedReports',
  initialState: {
    clientScopeMode: 'all',
    selectedClientIds: [],
  },
  reducers: {
    setClientScopeMode: (state, action) => {
      state.clientScopeMode = action.payload === 'selected' ? 'selected' : 'all';
    },
    setSelectedClientIds: (state, action) => {
      state.selectedClientIds = uniqueClientIds(action.payload || []);
    },
    toggleSelectedClientId: (state, action) => {
      const clientId = action.payload;
      if (!clientId) {
        return;
      }

      if (state.selectedClientIds.includes(clientId)) {
        state.selectedClientIds = state.selectedClientIds.filter((item) => item !== clientId);
        return;
      }

      state.selectedClientIds = [...state.selectedClientIds, clientId];
    },
    resetCombinedReportScope: (state) => {
      state.clientScopeMode = 'all';
      state.selectedClientIds = [];
    },
  },
});

export const {
  setClientScopeMode,
  setSelectedClientIds,
  toggleSelectedClientId,
  resetCombinedReportScope,
} = combinedReportsSlice.actions;

export default combinedReportsSlice.reducer;